import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';

import { EditUserPage, MainPage, ProductPage, UserPage } from '@pages/loadable';

import { AppHead } from './-Head';
import type { IAppProps } from './App.typings';

import './App.css';

export const App: React.FC<IAppProps> = props => (
    <>
        <BrowserRouter>
            <AppHead />
            <Routes>
                <Route path="/" Component={MainPage} />
                <Route path="/product/:barcode/:action?" Component={ProductPage} />
                <Route path="/user/:userId/:action?" Component={UserPage} />
                <Route path="/user/edit" Component={EditUserPage} />
            </Routes>
        </BrowserRouter>
        {props.children}
    </>
);
